import { AppLoadingScreen } from '@/components/AppLoadingScreen';
import { SSOLoadingScreen } from '@/components/SSOLoadingScreen';
import { ErrorDisplay } from '@/components/ui';
import { useSSOTokenExchange } from '@/hooks/useSSOTokenExchange';
import { useWordPressLoginRedirect } from '@/hooks/useWordPressLoginRedirect';
import { isAnonAllowedPath } from '@/lib/anonAccess';
import { redirectToWordPressLogin } from '@/lib/wordpress-redirect';
import { Redirect } from 'expo-router';
import { Platform } from 'react-native';
import { useAuth } from '../lib/AuthContext';

export default function Index() {
  const { user, loading } = useAuth();
  const { ssoProcessing, ssoToken, ssoError } = useSSOTokenExchange();

  useWordPressLoginRedirect();

  if (loading) return <AppLoadingScreen stage="auth:loading" />;
  if (ssoProcessing) return <SSOLoadingScreen />;

  if (ssoError) {
    return (
      <ErrorDisplay
        error={ssoError}
        title="Login failed"
        message="There was a problem signing you in. Please try again."
        onRetry={() => redirectToWordPressLogin()}
        retryText="Try logging in again"
      />
    );
  }

  // Anon users on `/` aren't effectively logged in (root isn't anon-allowed),
  // so we don't redirect them into the authenticated courses area. The
  // useWordPressLoginRedirect hook above will bounce them to WP login.
  if (user && !user.is_anonymous) return <Redirect href="/courses" />;

  if (Platform.OS !== 'web') return <Redirect href="/auth/login" />;

  const onAnonAllowedRoute =
    typeof window !== 'undefined' && isAnonAllowedPath(window.location.pathname);
  if (onAnonAllowedRoute) {
    return <AppLoadingScreen stage="auth:loading" />;
  }

  return <AppLoadingScreen stage={ssoToken ? 'auth:waiting_sso' : 'auth:redirecting'} />;
}
